export const ticketTypesInGroup = (group) => [
  ...(group.ticket_types || []),
  ...(group.sub_groups || []).flatMap(ticketTypesInGroup),
];

export const mergeTicketTypeUpdates = (group, updates) => {
  const updatesById = new Map(updates.map((update) => [update.id, update]));

  const merge = (node) => ({
    ...node,
    ticket_types: node.ticket_types
      ? node.ticket_types.map((ticketType) => (
        updatesById.has(ticketType.id) ? { ...ticketType, ...updatesById.get(ticketType.id) } : ticketType
      ))
      : node.ticket_types,
    sub_groups: node.sub_groups && node.sub_groups.length > 0
      ? node.sub_groups.map(merge)
      : node.sub_groups,
  });

  return merge(group);
};
